import React, { Component, Fragment } from "react";
import { app } from "js/namespaces";
import { LibraryTypeSelect } from "js/editor/PresentationLibrary/PresentationLibrary";
import { UIPaneContents, UIPaneSideBar, UIPaneWithSideBar } from "js/react/components/UiComponents";
import { PresentationLibrarySideBar, SideBarItem } from "js/editor/PresentationLibrary/PresentationLibrarySideBar";
import { PresentationFilters } from "common/constants";
import { Icon, Divider } from "@material-ui/core";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Gap10, Gap20, Gap5 } from "js/react/components/Gap";
import TeamTemplatesPane from "js/editor/TeamResources/TeamTemplatesPane";
import TeamSharedThemePane from "js/editor/TeamResources/TeamSharedThemePane";
import TeamCustomLoaderPane from "js/editor/TeamResources/TeamCustomLoaderPane";
import { TeamSlideLibraryPane } from "js/react/views/AddSlide/Panes/TeamSlideLibraryPane";
import TeamFoldersPane from "js/editor/TeamResources/TeamFoldersPane";
import { TeamAssetsPane } from "js/editor/TeamResources/TeamAssetsPane";
import { FeatureType } from "common/features";
import { UIController } from "js/editor/dialogs/UIController";
import styled from "styled-components";

const TeamResourceTypes = {
    TEAM_TEMPLATES: "templates",
    TEAM_SLIDES: "slides",
    TEAM_THEMES: "themes",
    TEAM_FOLDERS: "folders",
    TEAM_ASSETS: "assets",
    TEAM_CUSTOM_LOADER: "custom-loader",
};

const Styler = styled.div`
  width: 100%;
  .search-container {
    padding-top: 5px;
  }
`;

export class TeamResourcesPane extends Component {
    state = {
        selectedPane: TeamResourceTypes.TEAM_TEMPLATES
    }

    constructor(props) {
        super(props);

        if (props.defaultPane) {
            this.state.selectedPane = props.defaultPane;
        }
    }

    handleSelectResourceType = type => {
        this.setState({ selectedPane: type });
    }

    renderSelectedPane = () => {
        let { selectedPane } = this.state;

        switch (selectedPane) {
            case TeamResourceTypes.TEAM_TEMPLATES:
                return <TeamTemplatesPane />;
            case TeamResourceTypes.TEAM_SLIDES:
                return <TeamSlideLibraryPane organizationId={app.appState.orgId} isManageLibrary />;
            case TeamResourceTypes.TEAM_THEMES:
                return <TeamSharedThemePane organizationId={app.appState.orgId} />;
            case TeamResourceTypes.TEAM_FOLDERS:
                return <TeamFoldersPane />;
            case TeamResourceTypes.TEAM_ASSETS:
                return <TeamAssetsPane editable />;
            case TeamResourceTypes.TEAM_CUSTOM_LOADER:
                return <TeamCustomLoaderPane />;
        }
    }

    // NOTE: We have to use `className="selected"` instead of `props.selected`
    //   because a bug with `styled and` the application of `.dark-mode`
    selectedClass(filter) {
        return filter ? "selected" : "";
    }

    render() {
        let { selectedPane } = this.state;
        let { onSwitchType } = this.props;

        let isOwner = app.user.features.isFeatureEnabled(FeatureType.MANAGE_TEAM, UIController.getOrganizationId());

        return (
            <UIPaneWithSideBar>
                <UIPaneSideBar>
                    <LibraryTypeSelect libraryType="team-resources" onSwitchType={onSwitchType} />
                    <SideBarItem
                        className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_TEMPLATES)}
                        onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_TEMPLATES)}
                    >
                        <Icon>video_library</Icon>
                        Templates
                    </SideBarItem>
                    <SideBarItem
                        className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_SLIDES)}
                        onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_SLIDES)}
                    >
                        <Icon>recent_actors</Icon>
                        Slides
                    </SideBarItem>
                    <SideBarItem
                        className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_THEMES)}
                        onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_THEMES)}
                    >
                        <Icon>color_lens</Icon>
                        Themes
                    </SideBarItem>
                    <SideBarItem
                        className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_ASSETS)}
                        onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_ASSETS)}
                    >
                        <Icon>photo_camera_back</Icon>
                        Assets
                    </SideBarItem>
                    <SideBarItem
                        className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_CUSTOM_LOADER)}
                        onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_CUSTOM_LOADER)}
                    >
                        <Icon>play_circle_outline</Icon>
                        Player Branding
                    </SideBarItem>
                    {isOwner &&
                    <Fragment>
                        <Divider/>
                        <SideBarItem
                            className={this.selectedClass(selectedPane == TeamResourceTypes.TEAM_FOLDERS)}
                            onClick={() => this.handleSelectResourceType(TeamResourceTypes.TEAM_FOLDERS)}
                        >
                            <Icon>folder</Icon>
                            Team Folders
                        </SideBarItem>
                    </Fragment>
                    }
                </UIPaneSideBar>

                <Gap10 />

                <Styler>
                    {this.renderSelectedPane()}
                </Styler>
            </UIPaneWithSideBar>
        );
    }
}
